import React, {Component} from 'react';
import {Link, navigate} from "@reach/router";
import {checkMenu} from "../data/page_data";

//TODO new notif
class Navbar extends Component{
  
  constructor(props){
    super(props);
    this.state = {
      showmenu: '',
      hideheader: '',
      menu: this.props.data.menu
    };
    this.windowOffset = 0;
  }
  
  togglemenu = () =>{
    if(this.state.showmenu === ''){
      this.setState({showmenu: 'menu-active', hideheader: 'hi-inactive'})
      document.body.setAttribute('style', 'overflow: hidden')
    }else{
      this.setState({showmenu: '', hideheader: ''})
      document.body.setAttribute('style', '')
    }
  }

  componentWillUnmount(){
    document.body.setAttribute('style', '');
  }

  componentDidMount() {
    checkMenu(this.props.data.artist.id, this.props.data.artist.path, () => {
      var _menu = this.props.data.rebuildMenu();
      this.setState( state => ({menu: _menu}));
    });
  }

  back = ()=>{
    if(this.props.gohome == 1){
      navigate('home');
    }else window.history.back();
  }

  render(){
    return(
      <>
      <div className="header">
        <div className={['header-inner', this.state.hideheader].join(' ')}>
          <div className="header-left">
            <div className="btn btn-back" onClick={this.back}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.624 24.893"><g transform="translate(0)"><path className="a" d="M101.875,11.475,112.953.4a1.365,1.365,0,0,1,1.926,0l.816.816a1.363,1.363,0,0,1,0,1.926l-9.3,9.3,9.312,9.312a1.365,1.365,0,0,1,0,1.926l-.816.815a1.365,1.365,0,0,1-1.926,0L101.875,13.407a1.374,1.374,0,0,1,0-1.932Z" transform="translate(-101.478)"/></g></svg>
            </div>
          </div>
          <div className="header-center">{this.props.title}</div>
          <div className="header-right">
            <button className="btn btn-menu" onClick={this.togglemenu}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
              <g transform="translate(-73 9)">
                <rect transform="translate(73 -9)" />
                <path d="M0,14V12H8v2ZM0,8V6H16V8ZM0,2V0H16V2Z" transform="translate(87 6)" />
              </g>
            </svg></button>
          </div>
        </div>
        <div className={['menu-wrapper', this.state.showmenu].join(' ')}>
          <div className="menu">
            <div className="menu-all">
              <div className="menu-top">
                <ul>
                  <li><Link className="btn" to={this.props.data.prefix + 'home'}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                      <path d="M15,0,0,11.266V30H11.172V17.7h7.656V30H30V11.266Z" />
                    </svg></Link></li>
                  <li><Link className="btn btn-notif" to={this.props.data.prefix + 'account'}>
                  <svg className="btn-notif-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                      <g transform="translate(0)">
                        <path d="M133.941,335.266a7.606,7.606,0,0,0-7.6,7.6c0,.242.012.482.034.718a15.038,15.038,0,0,0,15.125,0c.022-.237.034-.476.034-.718a7.606,7.606,0,0,0-7.6-7.6Zm0,0" transform="translate(-118.942 -315.621)" />
                        <path d="M25.606,4.393A15,15,0,0,0,4.393,25.607a15.2,15.2,0,0,0,1.265,1.131,9.373,9.373,0,0,1,5.786-8.148,6.527,6.527,0,1,1,7.109,0,9.373,9.373,0,0,1,5.786,8.148,15.246,15.246,0,0,0,1.265-1.131,15,15,0,0,0,0-21.213Zm0,0" />
                        <path d="M184.14,147.238a4.769,4.769,0,1,0-4.769,4.769A4.775,4.775,0,0,0,184.14,147.238Zm0,0" transform="translate(-164.371 -134.121)" />
                      </g>
                    </svg>
                    <span className="new-notif"></span>
                    </Link>
                  </li>
                  <li><button className="btn btn-menu-close" onClick={this.togglemenu}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M24,3.977,20.023,0,12,8.023,3.977,0,0,3.977,8.023,12,0,20.023,3.977,24,12,15.977,20.023,24,24,20.023,15.977,12Z" />
                    </svg>
                  </button></li>
                </ul>
              </div>
              <div className="menu-bottom">
                {this.state.menu}
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
    );
  }
}

export default Navbar;
